<template>

<div id="preloader" ref="preloader">
    <div class="text" ref="counter">
        <p v-if="isFontLoaded">{{ currentLoadNum }}</p>
    </div>
    
    <video v-if="loadVideo" class="fake-video" ref="fakeVideo"></video>
</div>

</template>

<script>
import axios from "axios"
import WebFontLoader from "webfontloader"
import { TweenLite } from "gsap/all"

export default {

    data: function() {
        return {
            currentLoadNum: 0,
            isFontLoaded: false,
            timePassed: 0,
            loadVideo: false,
        }
    },

    mounted() {
        
        this.timePassed = new Date();

        // LOAD FONT FIRST!! Site is blank until font is loaded
        const config = {
            fontinactive: (familyName, fvd) => {
                throw new Error('Font Failed: ', familyName, fvd)
            },
            // fontactive: (familyName, fvd) => {},
            active: () => {
                this.onFontsLoaded()
            },
            custom: {
                families: ['Studio6'],
                urls: ['/fonts/fonts.css'],
            }
        }
        WebFontLoader.load(config)
        
    },


    
    
    
    methods: {
        
        onFontsLoaded() {
            // console.log('isFontLoaded');
            
            this.isFontLoaded = true
            
            // GET JSON FROM HOME! - TODO Add fetchHomeData function in Store instead
            let url = "/data/home.json"
            axios.get(url)
                .then(res => {
                    
                    // Store JSON Data
                    this.$store.dispatch('saveHomeData', res.data)
                    
                    this.loadVideo = (this.$router.currentRoute.name === 'Home') ? true : false
                    if (this.loadVideo) {
                        let url = res.data.introVideo.url
                        this.req = new XMLHttpRequest();
                        this.req.open('GET', url, true);
                        this.req.responseType = 'blob';
                        this.req.onload = this.onVideoLoaded
                        this.req.onprogress = this.onVideoLoading;
                        this.req.send();

                        // Show preloader coutner
                        TweenLite.to(this.$refs.counter, 0.5, {delay: 0.3, opacity: 1})
                        
                    } else {
                        this.onComplete()
                    }
                    
                })
                .catch(error => {
                    throw new Error('Data Failed: ', error);
                })
                
            
            
        },
        
        onVideoLoading(event) {
            if (event.lengthComputable) {
                // loaded = bytes the browser received
                // total = the total bytes set by the header (server side)
                var percentComplete = (event.loaded / event.total) * 100
                this.currentLoadNum = Math.round(percentComplete);
                
            } else {
                throw new Error('Preloader fail to get video size')
            }
        },
        
        
        onVideoLoaded() {
            if (this.req.status === 200) {
               this.onComplete()
            }
        },
        
        
        onComplete() {
            var now = new Date()
            var timePassed = (now - this.timePassed)/1000
            
            // Only fade out preloader if it's been visible for more than 2 sec
            if (timePassed > 2) {
                TweenLite.to(this.$refs.preloader, 0.5, {autoAlpha: 0})
            } else {
                TweenLite.set(this.$refs.preloader, {autoAlpha: 0})
            }
            
            this.$emit('loaded')
        },
        
    },
}
</script>

<style lang="scss" scoped>

// @import '../scss/variables';
// @import '../scss/font-scaling';

$primary-menu-top-offset: 80px;
$primary-menu-bottom-offset: 100px;

#preloader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #fff;
    // transition: opacity 0.5s;
    // 
    // &.loaded {
    //     opacity: 0
    // }
    
    .text {
        position: absolute;
        top: 80px;
        left: 6%;
        opacity: 0;
        
        p {
            color: #000;
            font-size: calc((100vh - #{$primary-menu-top-offset} - #{$primary-menu-bottom-offset}) / 6);
            line-height: 0.9em;
            font-display: block;
            
            &:not(:last-child) {
                padding-bottom: calc(((100vh - #{$primary-menu-top-offset} - #{$primary-menu-bottom-offset}) / 5) * 0.1);
            }   
        }
    }
}

</style>
